import { render, staticRenderFns } from "./RemoveUsersModal.vue?vue&type=template&id=dc2c0904"
import script from "./RemoveUsersModal.vue?vue&type=script&lang=js"
export * from "./RemoveUsersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports